import { PermissionData } from "@/definitions/types/permissions/permissions"
import { axiosApi } from "@/lib/api/axiosApi"

export const getPermissions =
  async (): Promise<PermissionData> => {
    const response = await axiosApi.get<PermissionData>(
      "/users/permissions"
    )

    return response.data
  }
